import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { IonHeader, IonToolbar, IonTitle, IonButton, IonIcon, IonContent, IonList, IonItem, IonLabel } from '@ionic/angular/standalone';
import { ModalController } from '@ionic/angular/standalone';
import { SexyModule } from '@qid/sexy';
import { Industry } from '../../model/industry.model';
import { IndustryService } from '../../services/industry.service';
import { CreateIndustryPage } from '../create-industry/create-industry.page';

@Component({
  selector: 'app-list-industry',
  templateUrl: './list-industry.page.html',
  styleUrls: ['./list-industry.page.scss'],
  standalone: true,
  imports: [
    FormsModule,
    IonHeader,
    IonToolbar,
    IonTitle,
    IonButton,
    IonIcon,
    IonContent,
    IonList,
    IonItem,
    IonLabel,
    SexyModule
  ]
})
export class ListIndustryPage implements OnInit {
  public industries: Industry[] = [];

  constructor(
    private industryService: IndustryService,
    private modalController: ModalController,
    private router: Router,
  ) {
  }

  ngOnInit() {
  }

  ionViewDidEnter() {
    this.fetchIndustries();
  }

  async fetchIndustries() {
    this.industries = await this.industryService.readAll(null);
  }

  openIndustry(industry) {
    this.router.navigateByUrl('menu/view-industry/' + industry._id);
  }

  public async addIndustry() {
    const modal = await this.modalController.create({
      component: CreateIndustryPage,
      componentProps: {
        parentIndustry: null,
      },
    });
    await modal.present();
    await modal.onDidDismiss();
    await this.fetchIndustries();
  }
}
